import React, { useEffect, useRef, useState } from "react";
import { Params, Route, RouteProps, useParams } from "react-router-dom";
import { useLogger } from "../../helpers/logger";
import { PageMap, PAGE_PATHS, usePageContext } from "./PageContext";
import { SessionMode } from "../../contexts/appStore/hooks";

export const generateRoute = <M extends SessionMode, T extends PageMap[M]>(mode: M, page: T, element: React.ReactNode, routeProps?: RouteProps) => {
  return <Route {...routeProps} path={(PAGE_PATHS[mode] as any)[page]} element={<PageComponent mode={mode} page={page} element={element} />} />;
};

export interface PageComponentProps<M extends SessionMode, T extends PageMap[M]> {
  mode?: M;
  page?: T;
  element: React.ReactNode;
}

export const PageComponent = <M extends SessionMode, T extends PageMap[M]>({ mode, page, element }: PageComponentProps<M, T>) => {
  const pageContext = usePageContext();
  const params = useParams();
  const [ready, setReady] = useState(false);
  const [content, setContent] = useState<React.ReactNode>();
  const paramsRef = useRef<Readonly<Params<string>>>();
  const logger = useLogger();

  useEffect(() => {
    logger.log(`[PAGE:${page?.toUpperCase()}] - enter: `, window.location.href);
    return () => {
      logger.log(`[PAGE:${page?.toUpperCase()}] - leave: `, window.location.href);
    };
  }, []);

  useEffect(() => {
    setReady(false);
    setContent(element);
  }, [element]);

  useEffect(() => {
    paramsRef.current = params;
  }, [params]);

  useEffect(() => {
    if (mode && page) {
      pageContext?.update(mode, page, paramsRef.current);
      setReady(true);
    }
  }, [mode, page, content]);

  if (!ready) return null;
  return <>{content}</>;
};

export default PageComponent;
